export const  discoveryMiiDescriptions = {
    label:'Transform your client discovery calls and multiply your outcomes.',
    labelForm: 'Discovery Notepad.',
    descriptionForm: "To ensure that you don't miss any important information during a discovery call , It's best to take notes of the key insights.",
    descriptionForm2: 'Please record these insights in the',
    description:'Jot down important details and capture key insights that will help you build a more engaging and effective dialogue.',
    description2: 'By transforming your client discovery calls and with our tool and leveraging the power of AI, you can multiply your outcomes and achieve greater success in your sales and recruitment efforts.',
    header: 'BuildMii a Job Description',
}

export const discoveryMiiFormatOptions = [
    {
        id: 1,
        name: 'Additional context to my notes',
        value: 'notepadFormat'
    },
    {
        id: 2,
        name: 'Job Description in 4R format',
        value: 'fourRFormat'
    },
    {
        id: 3,
        name: 'Job Description in scorecard format',
        value: 'scorecardFormat'
    },
    {
        id: 4,
        name: 'Summary and Closing',
        value: 'freeFormFormat'
    },
    {
        id: 5,
        name: 'Send a "Thank You" Email',
        value: 'thankYouFormat'
    },
    {
        id: 6,
        name: 'Next Steps',
        value: 'nextStepFormat'
    }
]

export const discoveryMiiPrompts = {
    entryPrompt: 'You are a Hiring Manager with extensive experience. \nYou are on a call with the client to understand their resource requirements. \nGiven the following information:'
}